const url =
  "https://sheets.googleapis.com/v4/spreadsheets/1iFjNl76JIxR4yU9b3Kyk1IeRk6A4UcbDPHKJFjtQeFY/values/Sheet1?alt=json&key=AIzaSyApxSS-I9j1vr9Ifw5NZfC-d6wjjuP-Cnw";
const employee = {
  agreement: {},
  owner: [{}],
  NeadAnalysis: {},
  account: [{}],
  beneficiaries: [{}],
  Policy: {
    // riskCreadit: "לא מאשר",
    // riskForward: "לא מאשר",
    // riskOTC: "כן מאשר",
    // riskOptions: "לא מאשר",
    // riskShort: "לא מאשר",
    // riskStrcture: "לא מאשר",
    // riskTashkif: "לא מאשר",
  },
  files: {
    // AAagreement: true,
    // isSendToSign: "כן",
  },
  apendix: {
    marketer: "",
    date: "",
  },
};

const template = [
  {
    fieldNumber: null,
    page: "agreement",
    object: "agreement",
    component: "agreement",
    _uid: "date",
    caption: "הסכם לניהול תיקי השקעות\nשנערך ביום ____________",
    Type: "dxDateBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 1,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "firstName",
    caption: "שם פרטי",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 2,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "lastName",
    caption: "שם משפחה",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 3,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "email",
    caption: "דואר אלקטרוני",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "אימייל תקין",
    visible: "",
  },
  {
    fieldNumber: 5,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "id",
    caption: "תעודת זהות",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "ת.ז. תקינה",
    visible: "4",
  },
  {
    fieldNumber: 8,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "city",
    caption: "עיר",
    Type: "",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "false",
  },
  {
    fieldNumber: 9,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "street",
    caption: "רחוב",
    Type: "",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "false",
  },
  {
    fieldNumber: 10,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "streetNumber",
    caption: "מס'",
    Type: "",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "false",
  },
  {
    fieldNumber: 11,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "zipCode",
    caption: "מיקוד",
    Type: "",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "false",
  },
  {
    fieldNumber: 12,
    page: "agreement",
    object: "agreement",
    component: "agreement",
    _uid: "sendMail",
    caption: "משלוח דואר רגיל",
    Type: "SelectBoxMulti",
    Value: "דואר רגיל|דואר אלקטרוני|כתובת נוספת / אחרת",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 15,
    page: "agreement",
    object: "agreement",
    component: "agreement",
    _uid: "sendMailOther",
    caption: "כתובת למשלוח דואר נוספת / אחרת",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "14",
  },
  {
    fieldNumber: 21,
    page: "account",
    object: "account",
    component: "account",
    _uid: "fee",
    caption: "דמי ניהול",
    Type: "dxNumberBox",
    Value: "",
    editByRep: true,
    editByClient: false,
    visibleToClient: true,
    require: true,
    validation: "עד 1%, עד 3 ספרות אחרי הנקודה",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "agreement",
    object: "agreement",
    component: "agreement",
    _uid: "lblFee",
    caption:
      'דמי ניהול תיק קרנות/נכסים פיננסים (100%)\n8.7 . ככלל, מור השקעות לא תגבה דמי ניהול חודשיים בגין ניהול נכס פיננסי שלמנהל התיקים יש זיקה אליו ואלו\nייגבו על-ידי מנהל הנכס הפיננסי.\nמור בית השקעות ניהול תיקים בע"מ\nגרסה 12\nלקוח פרטי\n- 7 -\n8.8 . ידוע ללקוח והלקוח מסכים כי בכל מקרה בו יבחר מנהל התיקים להשקיע, בהתאם למדיניות ההשקעות,\nבניירות ערך ובנכסים פיננסיים הלקוח יהיה מחויב בדמי ניהול ובדמי נאמנות כמפורט בתנאי אותם ניירות\nערך ונכסים פיננסיים כפי שיהיו מעת לעת.\n8.9 . ידוע ללקוח והלקוח מסכים לכך, כי השקעה בניירות ערך ובנכסים פיננסיים מסווימים, עשוי הלקוח להיות\nמחויב בדמי ניהול ובדמי נאמנות כמפורט בתנאי אותם ניירות ערך ונכסים פיננסיים כפי שיהיו מעת לעת.\nבהתאם, הלקוח מודע ומסכים לכך, כי שיעור דמי הניהול שייגבה מתיקו במקרה כאמור אינו צפוי ואינו\nבשליטת מנהל התיקים וכי הוא צפוי להשתנות, מעת לעת, בהתאם לשיקול דעתו הבלעדי של מנהל הנכס\nהפיננסי.\n8.10 . עוד מובהר כי בגין החזקה בחשבון של יחידות בקרנות נאמנות המנוהלות בידי חברה קשורה למור\nהשקעות, לא ייגבו על-ידי מור השקעות דמי ניהול מהחשבון. בגין יחידות כאמור, ייגבו תשלומים\nשמשלמת קרן הנאמנות למנהלה )שכאמור לעיל, למור השקעות אין שליטה על דמי הניהול הנגבים מכל\nקרן נאמנות(, וכן השכר לנאמן, כקבוע בתשקיפי קרנות הנאמנות ועמלות אחרות כקבוע בדין. יובהר, כי\nדמי הניהול המיוחסים לקרנות הנאמנות אינם ניתנים לשינוי שכן הם קבועים כלפי כל מחזיקי היחידות\nשל קרנות הנאמנות, ועפ"י הוראות הדין נאסר על ביצוע החזר ללקוח בגין דמי הנהול שנגבו מקרנות\nהנאמנות. לפירוט שעור דמי הנהול בקרנות הנאמנות המנוהלות בידי צד קשור, כפי שיהיו מעת לעת, ראה\nבאתר החברה - www.moreinvest.co.il .\n8.11 . הוסבר ללקוח, כי ככל שבתיקו יוחזקו אך ורק יחידות של קרנות נאמנות שמנוהלות ע " י חברה אחות של\nמנהל התיקים )חברה קשורה( ו/או מזומנים/פקדונות, מנהל התיקים לא יגבה דמי ניהול ישירות מהתיק\nבגין נכסים כאמור )אולם יהיה זכאי לקבל ממנהל הקרן חלק מדמי הניהול הנגבים בידי מנהל הקרן בגין\nיחידות של הקרנות המוחזקות(. מודגש, כי מנכסי תיקו של הלקוח יגבו ע "י מנהל הקרן )שהינו כאמור\nחברה קשורה למנהל התיקים( דמי ניהול בגין שכר מנהל הקרנות של יחידות כאמור )ושכר נאמן לנאמן\nהקרנות(. מובהר, כי אין בידי מנהל התיקים לקבוע את שיעור דמי הניהול/שכר הנאמן שגובה מנהל\nהקרנות/נאמן הקרנות בגין היחידות כאמור',
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "agreement",
    object: "agreement",
    component: "agreement",
    _uid: "lblFee2",
    caption:
      '. עמלות לבנק/חבר בורסה\n9.1 . ידוע ללקוח כי עבור כל פעולה ו/או עסקה יגבה הבנק עמלה מהלקוח לפי התעריף התקף בעת ביצוע הפעולה\nאו לפי תעריף המוסכם בינו לבין הלקוח. ידוע ללקוח שהבנק עשוי להיות זכאי לעמלות שונות אשר אינן\nנהוגות כיום, ואשר תהיינה נהוגות ו/או מקובלות בעתיד.\n9.2 . בהתאם להסכמים שבין הלקוח לבנק, הבנק עשוי לשנות מעת לעת את שיעורה של כל עמלה וכן לגבות\nעמלות ותשלומים נוספים, ועל הבנק חלה האחריות לעדכן את הלקוח בדבר שינוי כאמור.\n9.3 . יובהר, כי למור השקעות אין שליטה ו/או אחריות על העמלות הנגבות בידי הבנק מתיק ההשקעות של\nהלקוח ולא תחול עליה האחריות לעדכן את הלקוח בכל מקרה של שינוי בעמלות הבנק.\n9.4 . יובהר, כי בכל מקרה מור השקעות לא מקבלת ולא תקבל החזרי עמלות ביצוע מהבנק, במישרין או\nבעקיפין, ואם התקבל החזר מעין זה, הוא יועבר ללקוח.\n10 . הצהרות והתחייבויות מור השקעות\n10.1 . מור השקעות מתחייבת לפעול בנאמנות כלפי הלקוח במתן השירותים נשוא הסכם זה, בהסתמך על\nשיקולים מקצועיים בלבד, לפי מיטב הבנתה ושיקול דעתה, בהתאם למתחייב על פי הוראות הדין, וכללי\nהבורסה.\n10.2 . מור השקעות מצהירה בזאת כי היא עומדת ותעמוד בתקופת הסכם זה בדרישות הדין לעניין ההון העצמי,\nביטוח, ערבות בנקאית, או פיקדון ניירות ערך בסכומים, בשיעורים ובתנאים הנדרשים על פי החוק\nוהתקנות שהותקנו על-פיו.\n10.3 . מור השקעות מצהירה בזאת כי היא ועובדיה, המנהלים תיקי השקעות, הם בעלי רישיון כדין, וכי הם\nעומדים ויעמדו בדרישות כל דין בדבר הכשרתם המקצועית, כפי שתהיה מעת לעת.\nמור בית השקעות ניהול תיקים בע"מ\nגרסה 12\nלקוח פרטי\n- 8 -\n10.4 . מור השקעות תפנה לבנק על מנת שהבנק יזכה/יחייב את החשבון בקשר לעסקאות בניירות ערך ובנכסים\nפיננסיים שביצעה מור השקעות עבור הלקוח ביום ביצוע העסקה. אם מסיבה שאינה תלויה במור\nהשקעות לא ניתן לבצע את הרישום בחשבון ביום ביצוע העסקה, יעשה הרישום בהתאם, ולא יאוחר\nמאשר ביום העסקים הבא, ובכל מקרה לפני פתיחת המסחר או מסירת הפקודות בכתב לבורסה, לפי\nהמוקדם מביניהם.\n11 . אחריות וסיכונים\n11.1 . הלקוח מצהיר בזה כי הוא מודע לסיכונים הכרוכים בניהול תיק ההשקעות על-פי התנאים המפורטים\nבהסכם זה ונספחיו, ולעובדה כי לא ניתן לחזות מראש את ההתפתחויות בשוק ההון ובשעריהם של ניירות\nהערך והנכסים הפיננסיים.\n11.2 . כמו כן, ידוע ללקוח והוא מסכים לכך, כי אין במתן השירותים על-ידי מור השקעות על-פי הסכם זה,\nמשום התחייבות להשיג תשואה כלשהי ו/או רווח מינימאלי ו/או רווח בשיעור כלשהו ו/או כדי לבטח את\nהלקוח מפני הפסדים ו/או כדי לערוב ו/או להתחייב לתוצאותיה ו/או להצלחתה של עסקה כלשהי\nשתבוצע על-ידי מור השקעות, או לשוויין של ההשקעות בחשבון, כל עוד פעלה מור השקעות על-פי הדין.\n11.3 . הלקוח מאשר כי ידוע לו שעל הכנסותיו עלולות לחול חובות דיווח לרשות המסים וכן עלולים לחול\nמיסים, היטלים אגרות ותשלומי חובה למיניהם לרבות מילוות )ובמיוחד בהתחשב בכמות הפעולות\nשתבוצענה בחשבון ו/או בהיקף העסקאות בחשבון(. הלקוח לבדו יישא בכל ההתחייבויות והתשלומים\nהנ"ל, אם יהיו כאלה. אם תחויב מור השקעות לשלמם, תשלומים אלו יהיו חוב של הלקוח כלפי מור\nהשקעות ויחויבו בחשבון הלקוח לפירעון מיידי.\n11.4 . כל זכות וכל הרשאה שיש למור השקעות, זכאית היא להפעילן או להימנע מלהפעילן לפי שיקול דעתה\nוללקוח לא תהיה כל טענה עקב כך.\n11.5 . מובהר כי ההתקשרות בהסכם זה הינה למטרת ניהול נכסי החשבון על-ידי מור השקעות. לפיכך, אם\nיינתנו על-ידי הלקוח הוראות לביצוע עסקאות בחשבון, ולדעת מור השקעות, העסקאות כאמור פוגעות\nאו עתידות לפגוע בניהול נכסי החשבון, תהיה מור השקעות רשאית להפסיק את מתן השירותים על-פי\nהסכם זה, באופן מיידי, וללקוח לא תהיה כל טענה עקב כך.\n11.6 . מור השקעות תהיה פטורה מכל אחריות בגין נזק, הפסד, מניעת רווחים או הוצאות מסוג כלשהו, שייגרמו\nללקוח בקשר עם ניהול החשבון ו/או תיק ההשקעות של הלקוח, ואשר נגרמו כתוצאה מנסיבות שאינן\nבשליטתה של מור השקעות.\n12 . העדר אשראי\n12.1 . הלקוח מאשר למור השקעות לנהל את תיק ההשקעות אך ורק במסגרת נכסים המצויים לזכותו בחשבון\nומור השקעות לא תפעל במסגרת אשראי, למעט ככל שניתנה הרשאת הלקוח במפורש לפעולה כאמור\nולמסגרת האשראי בחשבון.\n12.2 . ידוע לצדדים, כי בכל מקרה, הבנק יהיה רשאי, לפי שיקול דעתו, לסרב לבצע פקודה או להתנותה בתנאי\nכלשהו, אם יש בביצוע הפקודה כדי להביא לחריגה ממסגרת האשראי או הביטחונות העומדת\nלרשות הלקוח בחשבון, וזאת מבלי לגרוע מכל זכות אחרת של הבנק לסרב לבצע הוראה, כקבוע בכל\nהסכם אחר בין הלקוח והבנק, וכי מור השקעות לא תהה אחראית לנזק שייגרם עקב סרוב הבנק לבצע\nפעולה כאמור.\n13 . מיופה כח\n13.1 . הלקוח רשאי למנות מיופה כח מטעמו לצורך קבלת מידע בכל הנוגע לחשבון ו/או לצורך מסירת הוראות\nלביצוע פעולות בחשבון ו/או בניירות הערך ו/או בנכסים הפיננסיים, וזאת על-ידי מתן הודעה מוקדמת\nבכתב למור השקעות, בצירוף ייפוי כח בנוסח המקובל אצל מור השקעות, חתום על-ידי הלקוח ומיופה\nהכוח כאשר חתימות אלה מאושרות על-ידי עובד מור השקעות או על-ידי עו"ד.\n13.2 . מיופה כח מטעם הלקוח יהיה מוסמך לבצע כל פעולה ולתת כל הוראה אשר הלקוח רשאי לבצע בקשר\nעם החשבון/ניירות הערך/נכסים פיננסיים, בכפוף לאמור בהסכם זה, ובכפוף לכך שהלקוח הסמיכו\nבהודעה האמורה לעיל לבצעה, ואולם מינוי מיופה כוח לא יגרע במאומה מסמכותו של הלקוח להמשיך\nולתת הוראות ולבצע פעולות בקשר עם החשבון – בכפוף לאמור בהסכם זה.\nמור בית השקעות ניהול תיקים בע"מ\nגרסה 12\nלקוח פרטי\n- 9 -\n13.3 . מובהר כי במקרה של קבלת הוראות סותרות או מנוגדות מהלקוח וממיופה הכוח, תפעל מור השקעות\nעל-פי הוראתו של הלקוח בלבד.\n13.4 . מור השקעות לא תהיה אחראית בכל מקרה בו חרג מיופה הכוח מסמכותו או פעל בניגוד לחובת נאמנות\nו/או חובת הגילוי ו/או כל חובה אחרת שתהיה לו, אם תהיה לו, כלפי הלקוח וכל פעולה כאמור של מיופה\nהכוח תחייב את הלקוח לכל דבר ועניין ובלבד שמור השקעות פעלה בהתאם לאמור בהודעה על מינוי\nמיופה הכוח.\n14 . חשבון משותף\n* סעיף זה יחול רק במקום בו קיים חשבון משותף לשניים או יותר.\n14.1 . במקרה והחשבון הינו חשבון משותף ביחד עם לקוח אחר, בין אם נפתח מלכתחילה ככזה ובין אם נעשה\nלמשותף בכל עת לאחר פתיחתו, יהיה כל אחד מבעלי החשבון, לבדו, רשאי לתת למור השקעות הוראות\nופרטים בנוגע לבירור צרכי לקוח, אלא אם כן הורו בעלי החשבון בכתב אחרת.\n14.2 . הוראה שנמסרה למור השקעות על-ידי מי מבעלי החשבון תחייב את כל השותפים בחשבון לכל דבר ועניין,\nולבעלי זכויות אחרים בחשבון לא תהיינה כל טענות כנגד מור השקעות בגין כך.\n14.3 . ניתנו הוראות סותרות ו/או נוגדות על-ידי בעלי החשבון תפעל מור השקעות על-פי ההוראה האחרונה\nשהתקבלה, אם טרם בוצעה ההוראה או ההוראות הקודמות.\n14.4 . כל המופקד בחשבון וכל ניירות הערך והנכסים הפיננסיים הכלולים בחשבון, וכן כל זכויותיהם של\nהשותפים בחשבון כלפי מור השקעות, ייחשבו ככל שהדבר נוגע למור השקעות, כשייכים לכל השותפים\nיחדיו, ללא קשר לזהות השותף בחשבון אשר הפקיד כספים ו/או נכסים בחשבון, או היה בעלים שלהם\nקודם להפקדתם בחשבון.\n14.5 . לעניין פטירת שותף בחשבון משותף, ראה סעיף 16 להלן.\n15 . דיווח ללקוח\n* הוראת סעיף זה תחול חלקית על ניהול חשבון בנאמנות עיוורת בהתאם לפרטים בנספח ו\' להסכם זה.\n15.1 . מור השקעות תמסור ללקוח כל מידע שיידרש על-ידו בעניין החשבון, לרבות יתרות יומיות של ניירות ערך\nונכסים פיננסיים, דו"חות תשואות תקופתיים ולרבות פרטים לגבי עסקה ספציפית, אלא אם כן יהיו\nדרישות המידע של הלקוח או תדירותן, בלתי סבירות לדעת מור השקעות.\n15.2 . הלקוח מתחייב לבדוק כל דיווח, או מסמך שתמסור לו מור השקעות, ולהודיע למור השקעות בכתב, תוך\n7 ימי עסקים ממועד הגעת הדיווח לידיו, על כל הסתייגות שתהיה לו לגביו, אם תהיה.\n15.3 . ידוע ומוסכם על הלקוח כי כל דיווח, הודעה או מסמך שנשלחו ללקוח, כאמור ושלגביהם הגיעו\nהסתייגויות הלקוח בכתב למור השקעות, לאחר המועד האמור, מור תבחן ותברר מול הבנק שבו החשבון\nמנוהל את נכונות הסתייגויות הלקוח, ותעשה את מירב המאמצים על למנת לנסות לתקנם )אם אכן\nשגויים(.\n15.4 . הדיווח התקופתי יישלח ללקוח בדואר. במקרה שהלקוח מעוניין לקבל את הדיווחים באמצעות הדואר\nהאלקטרוני בלבד, עליו למסור כתובת מתאימה וכן לעדכן בדבר כל שינוי בכתובת הדוא"ל. הלקוח\nמסכים לכך כי הדיווח על-ידי מור השקעות באמצעות הדואר האלקטרוני מהווה תחליף מלא ושלם\nלשליחת הדיווחים על ידי החברה בכל אמצעי תקשורת אחר, לרבות באמצעות הדואר.\n15.5 . הלקוח רשאי בכל עת לחזור בו מהסכמתו לקבל דיווחים בדואר אלקטרוני בלבד, באמצעות מתן הודעה\nעל כך בכתב למור השקעות.\n16 . פטירת לקוח\n16.1 . במקרה של פטירת אחד השותפים בחשבון, ימסרו יתר השותפים הודעה בכתב על כך לאלתר למור\nהשקעות, ועזבונו של המנוח יבוא במקומו בכל הקשור לחשבון ו/או להסכם זה.\n16.2 . מבלי לגרוע מכלליות האמור לעיל, בכל מקרה שייוודע למור השקעות על פטירת שותף בחשבון כאמור,\nתהיה מור השקעות רשאית להימנע מביצוע כל פעולה בחשבון ומביצוע כל הוראה שתקבל בקשר עם\nהחשבון מבלי לקבל את אישור השותפים לחשבון ואישור מנהל העיזבון, ויחולו כללי הבנקאות למקרה\nשל מות שותף בחשבון או ההוראות הקבועות לעניין זה בהסכם שבין בעלי החשבון לבנק, ככל שנקבעו\nהוראות כאמור. אם ביצעה מור השקעות פעולה בחשבון על-פי הוראת שותף לחשבון, והוראה זו הינה\nמור בית השקעות ניהול תיקים בע"מ\nגרסה 12\nלקוח פרטי\n- 10 -\nבניגוד לאמור בכללי הבנקאות ו/או לקבוע בהסכם שבין בעלי החשבון לבנק, לפי העניין, לא תשא מור\nהשקעות באחריות בגין פעולה כאמור ותוצאותיה, כלפי בעלי החשבון הנותרים.\n16.3 . במקרה בו ללקוח שנפטר אין שותפים בחשבון, תהיה מור השקעות רשאית להימנע מביצוע כל פעולה\nבחשבון למעט פעולות הנדרשות לשם שמירת ערך החשבון ומניעת הפסדים, כל עוד לא הוגש למור\nהשקעות צו של בית משפט ממנו נתבררה, להנחת דעתה של מור השקעות, זכותם של אלה הנקובים בצו,\nלהורות למור השקעות כיצד לפעול.\n17 . סודיות\n17.1 . הלקוח מצהיר כי מסירת פרטי הזיהוי ונתונים אחרים למור השקעות, נעשית מרצונו החופשי וכי ידוע לו\nשהפרטים הנ"ל דרושים לצורך מתן השירותים ללקוח על פי הסכם זה. ידוע ללקוח והוא מסכים לכך כי\nהפרטים והנתונים שימסרו למור השקעות יוחזקו כולם או חלקם גם במאגרי מידע המוחזקים או\nשיוחזקו באמצעים מגנטיים ו/או אופטיים והמיועדים לעיבוד במחשב אצל מור השקעות ו/או מי מטעמה\nו/או אצל גופים מטעמה של מור השקעות העוסקים עבורה בהיבטים הטכניים או השיווקיים בקשר\nלשירותים שניתנים על-ידי מור השקעות.\n17.2 . מור השקעות תשמור בסודיות כל מידע המתייחס ללקוח שהלקוח הביא לידיעתה וכל מידע הנובע\nמהשירותים ולא תעשה בהם שימוש, אלא ככל הנדרש, לפי שיקול דעתה לביצוע השירותים על פי הסכם\nזה, אך זאת בכפיפות לחובת הגילוי והדיווח המוטלת על מור השקעות על-פי כל דין ועל-פי כללי הבורסה.\n17.3 . על אף האמור בסעיף 17.2 לעיל ובכפוף לכל דין, הלקוח מסכים שמור השקעות תהיה רשאית להעביר את\nהפרטים והנתונים האגורים או שיהיו אגורים במאגרי המידע הנ"ל, וכן כל מידע אחר שיהיה בידה בקשר\nעם הלקוח לצדדים שלישיים לצורך שירות אינטרס של הלקוח או קבוצת לקוחות עליה נמנה הלקוח,\nובלבד שאין בהעברת מידע זו כדי להטיל איזו חבות שהיא על הלקוח.\n18 . סיום ההתקשרות\n18.1 . הסכם זה יהיה תקף ממועד חתימתו על-ידי הצדדים לו, ועד לביטולו על-ידי הלקוח או על-ידי מור\nהשקעות, או עד לביטולו מכח כל דין.\n18.2 . הסכם זה יעמוד בתקפו כל עוד לא בוטל על-ידי מי מהצדדים. הודעה בדבר ביטול ההתקשרות בין\nהצדדים תינתן:\nעל-ידי הלקוח – למור השקעות ולבנק בו מנוהל חשבון הלקוח, בכל עת, בהודעה ובכתב.\nעל-ידי מור השקעות – בהודעה בכתב של שבעה ימים מראש.\n18.3 . בנוסף, מוסכם בזאת כי במקרה בו יודיע הלקוח על ביטול ההתקשרות כאמור במהלך יום מסחר או\nבמהלך יום עסקים בו מבצעת מור השקעות פעולות עבור הלקוח, תיכנס ההודעה על סיום ההתקשרות\nלתוקפה בתום יום המסחר העוקב.\n18.4 . עוד מוסכם בזאת כי במקרה בו יודיע הלקוח על סיום ההתקשרות כאמור לבנק בלבד, תסתיים\nההתקשרות נשוא הסכם זה, תוך 24 שעות ממועד שהגיע הדבר לידיעת מור השקעות; אולם הלקוח יהיה\nאחראי כלפי מור השקעות לכל נזק או הפסד שיגרמו לו, כתוצאה ישירה מהימנעות הלקוח ממסירת\nההודעה כאמור, גם למור השקעות.\n19 . שונות\n19.1 . בכפוף לקבלת הסכמת הלקוח בכתב, מור השקעות זכאית להמחות את כל זכויותיה וחובותיה על פי\nהסכם זה לחברה בת או חברה קשורה או מסונפת ולצד ג\' אחר. המחאה כאמור תעשה רק לאחר מתן\nהודעה מראש ובכתב ללקוח וקבלת הסכמת הלקוח.\n19.2 . מור השקעות תהיה רשאית שלא לפעול לפי הוראת הלקוח מקום בו הוראה זו סותרת את הוראות כל דין\nו/או תקנות, כפי שיהיו ו/או ישתנו מעת לעת.\n19.3 . כל שינוי, תיקון ו/או תוספת להסכם לא יהיה להם תוקף, אלא אם יעשו בכתב על ידי הלקוח ומור\nהשקעות.\n19.4 . על אף האמור בסעיף 19.3 לעיל, מוסכם בין הצדדים כי היה ויחול שינוי בכל דין אשר יחייב שינוי באחת\nאו יותר מהוראות הסכם זה ו/או הוספה ו/או מחיקת הוראות בו, יראו הסכם זה כאילו בוצע בו השינוי\nהנדרש ביום כניסת השינוי בדין לתוקפו.\nמור בית השקעות ניהול תיקים בע"מ\nגרסה 12\nלקוח פרטי\n- 11 -\n19.5 . סמכות השיפוט הבלעדית לדון בתביעות הנובעות מהסכם זה תהיה לבתי המשפט בתל אביב – יפו.\n19.6 . הסכם זה מבטל כל הסכם אחר או קודם שנחתם בין הצדדים.\n19.7 . כתובות הצדדים לעניין ביצוע ומתן הודעות בהסכם זה יהיו כמפורט ברישא הסכם זה.',
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "spam",
    object: "apendix",
    component: "spam",
    _uid: "lblSpam",
    caption: "אישורים מיוחדים",
    Type: "Header2",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 31,
    page: "spam",
    object: "apendix",
    component: "spam",
    _uid: "lblSpam2",
    caption:
      'דבר פרסומת, כהגדרתו בחוק התקשורת (בזק ושידורים), התשס"ח- 2008 , ו/או כל חומר שיווקי ו/או פרסומי אחר.',
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 32,
    page: "spam",
    object: "apendix",
    component: "spam",
    _uid: "lblSpam3",
    caption:
      'כחלק מהשירות ללקוח, חומרים מקצועיים וחומרים נוספים במטרה לעדכן את הלקוח ולהעשיר ידיעותיו\nבתחום ניהול ההשקעות ונלווים לו, כגון סקירה כלכלית, מאמרי דעה וכיוצ"ב',
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "spam",
    object: "apendix",
    component: "spam",
    _uid: "lblSpam4",
    caption:
      "כל זאת, כפי שסומן לעיל, באמצעות פקסימיליה, הודעה אלקטרונית, הודעת טקסט, מערכת חיוג אוטומטי ו/או\nבכל אופן אחר.\nהסכמה זו תחול ביחס לפרסומים מקצועיים מטעם מור השקעות ו/או מטעם תאגיד קשור לה.",
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 36,
    page: "NeadAnalysis",
    object: "agreement",
    component: "agreement",
    _uid: "linkBtwOwners",
    caption: "מהי מהות השיתוף בין בעלי החשבון",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "owner",
    object: "owner",
    component: "owner",
    _uid: "dob",
    caption: "תאריך לידה",
    Type: "dxDateBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 39,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "gender",
    caption: "מין",
    Type: "dxRadioGroup",
    Value: "זכר|נקבה",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 40,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "pep",
    caption: "איש ציבור|בן משפחה של אחד|שותף עסקי של אחד",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 41,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "pepDescription",
    caption: "פרט",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.owners[x].pep === 'כן'",
  },
  {
    fieldNumber: 42,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "resident ",
    caption: "תושב ישראל",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 43,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "linkToIsrael",
    caption: "אנא פרט את זיקת החשבון לישראל",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.owners[x].resident === 'לא'",
  },
  {
    fieldNumber: 44,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "citizenOther",
    caption: "ברשותי אזרחויות נוספות",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 45,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "citizen",
    caption: "מדינת אזרחות",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.owners[x].citizenOther === 'כן'",
  },
  {
    fieldNumber: 46,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "maritalStatus",
    caption: "מצב משפחתי",
    Type: "dxRadioGroup",
    Value: "רווק/ה|נשוי/אה|גרוש/ה|אלמן/ה",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 47,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "employeeStatus",
    caption: "מצב תעסוקתי",
    Type: "dxRadioGroup",
    Value: "שכיר|פנסיונר|שכיר בעל שליטה|בעל שליטה|לא עובד|עצמאי",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 48,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "employeePlace",
    caption: "תפקיד ומקום עבודה, אם פנסיונר יש לציין מקום עבודה אחרון",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 53,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "publicCompany",
    caption: "האם יש זיקה לחברה\nציבורית",
    Type: "dxRadioGroup",
    Value: "לא| כן ואין צורך במגבלות|כן ויש צורף במגבלות",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 54,
    page: "NeadAnalysis",
    object: "owner",
    component: "owner",
    _uid: "publicCompanyLimits",
    caption: "אנא לפרט את המגבלות",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.owners[x].publicCompany === 'כן ויש צורף במגבלות'",
  },
  {
    fieldNumber: null,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "lblNa1",
    caption:
      "שאלות אלו נועדו להבהיר את היכולת הפיננסית הקיימת והצפויה של הלקוח.",
    Type: "Header2",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 67,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "income",
    caption:
      "מהי ההכנסה הפנויה החודשית המוצעת? (הכנסה שוטפת בניכוי הוצאות שוטפות)",
    Type: "dxRadioGroup",
    Value:
      "שלילי - גרעון הגדול מ-10 אלף ש״ח בחודש|שלילי - גרעון הקטן מ-10 אלף ש״ח בחודש|מאוזן|חיובי - יתרה קטנה מ-10 אלף ש״ח בחודש|חיובי - יתרה גדולה מ-10 אלף ש״ח בחודש",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 68,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "assetes",
    caption: "האם קיימים נכסים בארץ או בחו״ל?",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 69,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "asstestOther",
    caption: "נכסים נוספים",
    Type: "dxTextArea",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.NeadAnalysis.assetes === 'כן'",
  },
  {
    fieldNumber: 70,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "investmentRange",
    caption: "טווח ההשקעה הצפוי",
    Type: "dxRadioGroup",
    Value: "עד שנתיים|שנתיים עד חמש שנים|מעל חמש שנים",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 71,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "liquid",
    caption:
      "האם בתקופה הנראית לעין תזדקק לכול הכסף או חלק ממנו לחלופין האם יש צפי לקבלת תשלומים נוספים?",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 72,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "liquidReasons",
    caption: "פרט סיבות אפשריות לצורך",
    Type: "dxTextArea",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.NeadAnalysis.liquid === 'כן'",
  },
  {
    fieldNumber: 73,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "knowledge",
    caption: "מהי רמת הידע והניסיון בשוק ההון? (ניתן לבחור יותר מאחת)",
    Type: "SelectBoxMulti",
    Value:
      "אין|ממסגרת לימודית|מהעיתונות|תיק מיועץ בבנק|תיק מנוהל|ניהלתי כספים לעצמי|אחר",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 74,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "knowledgeOther",
    caption: "אחר",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.NeadAnalysis.knowledge.includes('אחר')",
  },
  {
    fieldNumber: 75,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "protfolioValue",
    caption: "שערוך סכום תיק ההשקעות שאני מעוניין להעביר למנהל התיקים",
    Type: "dxNumberBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 76,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "protfolioPrecentage",
    caption: "אחוז התיק מסך הנכסים הנזילים",
    Type: "dxRadioGroup",
    Value: "עד 10%|10% עד 25%|25% עד 50%| מעל 50%",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 77,
    page: "NeadAnalysis",
    object: "account",
    component: "account",
    _uid: "fundSource",
    caption: "מקור הכספים המופקדים בחשבון המנוהל",
    Type: "SelectBoxMulti",
    Value:
      "עבודה|ירושה מקרבה ראשונה|מכירת נדל״ן|פיצויים|מכירת אופציות|אקזיט|מתנה מקרבה ראשונה|אחר",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 78,
    page: "NeadAnalysis",
    object: "account",
    component: "account",
    _uid: "fundSourceOther",
    caption: "אחר",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.account[x].fundSource.includes('אחר')",
  },
  {
    fieldNumber: 79,
    page: "NeadAnalysis",
    object: "account",
    component: "account",
    _uid: "fundUsage",
    caption: "מהו ייעוד הכסף?",
    Type: "SelectBoxMulti",
    Value:
      "רכישת מכס|סיוע למשפחה|פנסיה|ירושה לילדים|לקבל הכנסה שוטפת מהשקעה|אין ייעוד לכספים כרגע|אחר",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 80,
    page: "NeadAnalysis",
    object: "account",
    component: "account",
    _uid: "fundUsageOther",
    caption: "אחר",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.account[x].fundUsage.includes('אחר')",
  },
  {
    fieldNumber: 81,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "risks",
    caption:
      'השקעה בני"ע ונכסים פיננסיים כרוכה פעמים רבות בתנודתיות ובתקופות מסוימות שווי התיק עלול לרדת ולכן',
    Type: "dxRadioGroup",
    Value:
      "חשוב לי מאוד שהתיק לא יהיה תנודתי. אני מעדיף/ה השקעה עם תנודתיות מינימלית, גם אם הדבר יבוא על חשבון התשואה שאני עשוי/ה לקבל.|אני מעדיף/ה שהתנודתיות בתיק תהיה נמוכה ככל האפשר , לרבות הפסדים זמניים שיתקבלועל הדעת. חשוב לי יותר לשמור על ערך התיק מאשר להשיג תשואה גבוהה.|אני מבין/ה שעל מנת לקבל תשואה סבירה, עשוייה להיות תנודתיות סבירה בשווי התיק , וזהו הסיכון שאני מוכן/ה לקחת על מנת לקבל תשואה סבירה גם במחיר של הפסד זמני.| המטרה העיקרית שלי בטווח הארוך היא להגדיל את ערך השקעותי ומוכן לקחת סיכונים ותנודות חריפות בתיק ההשקעות.",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "NeadAnalysis",
    object: "NeadAnalysis",
    component: "NeadAnalysis",
    _uid: "behave",
    caption:
      "מה לדעתך תהיה תגובתך אם תיק ההשקעות שלך יציג הפסד של כ-10% בתקופה קצרה",
    Type: "dxRadioGroup",
    Value:
      "הייתי נלחץ מאוד ומיד מתקשר למנהל ההשקעות שימכור את כל התיק ויעבירו למזומן| לא הייתי מרוצה מהתוצאה וכנראה שהייתי מבקש להקטין את מרכיב המניות בתיק ההשקעות| לא אבצע שום שינוי השוק הוא מחזורי ולאורך זמן שוק ההון עולה|אנצל את ההזדמנות ואבקש להגדיל את מרכיבי הסיכון בתיק| לא יודע להעריך מה תהיה תגובתי, אפנה לייעוץ מקצועי",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "lblPolicy",
    caption: "מדיניות ההשקעה",
    Type: "Header2",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 87,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "lblPolicy1",
    caption:
      "נמוך - תנודתיות בתיק נמוכה, לרבות הפסדים זמניים ו/או רווחים נמוכים במטרה לשמור\nעל ערך התיק מאשר להשיג תשואה גבוהה",
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 87,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "lblPolicy1b",
    caption:
      "בינוני - תנודתיות בינונית בשווי התיק במטרה לנסות להשיג תשואה גבוהה. הלקוח מוכן\nלספוג הפסד מסוים במטרה להגדיל את הסיכוי לתשואות עודפות בתיק ההשקעות",
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 87,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "lblPolicy1c",
    caption:
      "גבוה - תנודתיות גבוהה במטרה להשיג תשואות גבוהות בתיק ההשקעות לאורך זמן.",
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 88,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "policyRecomandation",
    caption: "מדיניות השקעה מומלצת על ידי בעל.ת הרישיון",
    Type: "dxRadioGroup",
    Value:
      '1. פרופיל סיכון נמוך - מניות בארץ ובחו"ל - ללא אג"ח ממשלתי וחברות מדורגות בארץ ובחו"ל – ללא הגבלה 1 אג"ח לא מדורג* – עד 15% |\n2 . פרופיל סיכון נמוך - מניות בארץ ובחו"ל - עד 10% אג"ח ממשלתי וחברות מדורגות בארץ ובחו"ל – ללא הגבלה 1 אג"ח לא מדורג* – עד %15 |\n3 . פרופיל סיכון נמוך - מניות בארץ ובחו"ל - עד 20%. אג"ח ממשלתי וחברות מדורגות בארץ ובחו"ל – ללא הגבלה 1 אג"ח לא מדורג* – עד 20% |\n4 . פרופיל סיכון בינוני - מניות בארץ ובחו"ל - עד 30%. אג"ח ממשלתי וחברות מדורגות בארץ ובחו"ל – ללא הגבלה 1. אג"ח לא מדורג* – עד 20% |\n5 . פרופיל סיכון בינוני - מניות בארץ ובחו"ל - עד 40%. אג"ח ממשלתי, מדורגות בארץ ובחו"ל – ללא הגבלה 1. אג"ח לא מדורג* – עד 20% |\n6 . פרופיל סיכון גבוה - מניות בארץ ובחו"ל - עד 50% אג"ח חברות וממשלתי – ללא הגבלה* |\n7 . פרופיל סיכון גבוה - מניות בארץ ובחו"ל - עד 100% אג"ח חברות וממשלתי – ללא הגבלה* ',
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "lblPolicy2",
    caption:
      '*אגרת חוב קונצרנית ו/או אג"ח שהנפיקה מדינה שאינה מדינת ישראל, שאינה מדורגת, או שהיא מדורגת בדירוג נמוך ממדירוג\n( BBB -( ו/או דירוג מקביל לו והכל על-פי שיקול דעתו של מנהל התיקים.\n<br>\nסוגי נכסים שתיק ההשקעות עשוי לכלול:\n- החזקה ישירה של אג"ח ו/או מניות, בארץ ובחו"ל\n- קרנות נאמנות בארץ ובחו"ל כגון קרנות מנוהלות, קרנות מחקות וקרנות סל, לרבות כאלו המנוהלים על-\nידי צדדים קשורים\n- מזומן/פקדונות',
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "lblPolicy3",
    caption: "",
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 96,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "fundInvestment",
    caption: "התיק ינוהל באמצעות קרנות נאמנות, לרבות\nקרנות סל (קרנות קשורות)",
    Type: "dxRadioGroup",
    Value: "עד 50%|תיק קרנות|אחר",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 97,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "fundInvestmentOther",
    caption: "אחר",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.Policy.fundInvestment === 'אחר'",
  },
  {
    fieldNumber: 99,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "clientAcceptPolicy",
    caption: "הלקוח מקבל את המלצת בעל הרישיון",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 100,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "clientPolicyReason",
    caption: "הסבר מדוע אינך מקבל את\nהמלצת מנהל התיקים",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.Policy.clientAcceptPolicy === 'לא'",
  },
  {
    fieldNumber: 101,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "clientPolicyAsked",
    caption: "מהי המדיניות המבוקשת",
    Type: "Header2",
    Value: "שדות 1-7 (שורות 74-80)",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.Policy.clientAcceptPolicy === 'לא'",
  },
  {
    fieldNumber: 88,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "policyAsked",
    caption: "מדיניות השקעה מומלצת",
    Type: "dxRadioGroup",
    Value:
      '1. פרופיל סיכון נמוך - מניות בארץ ובחו"ל - ללא אג"ח ממשלתי וחברות מדורגות בארץ ובחו"ל – ללא הגבלה 1 אג"ח לא מדורג* – עד 15% |\n2 . פרופיל סיכון נמוך - מניות בארץ ובחו"ל - עד 10% אג"ח ממשלתי וחברות מדורגות בארץ ובחו"ל – ללא הגבלה 1 אג"ח לא מדורג* – עד %15 |\n3 . פרופיל סיכון נמוך - מניות בארץ ובחו"ל - עד 20%. אג"ח ממשלתי וחברות מדורגות בארץ ובחו"ל – ללא הגבלה 1 אג"ח לא מדורג* – עד 20% |\n4 . פרופיל סיכון בינוני - מניות בארץ ובחו"ל - עד 30%. אג"ח ממשלתי וחברות מדורגות בארץ ובחו"ל – ללא הגבלה 1. אג"ח לא מדורג* – עד 20% |\n5 . פרופיל סיכון בינוני - מניות בארץ ובחו"ל - עד 40%. אג"ח ממשלתי, מדורגות בארץ ובחו"ל – ללא הגבלה 1. אג"ח לא מדורג* – עד 20% |\n6 . פרופיל סיכון גבוה - מניות בארץ ובחו"ל - עד 50% אג"ח חברות וממשלתי – ללא הגבלה* |\n7 . פרופיל סיכון גבוה - מניות בארץ ובחו"ל - עד 100% אג"ח חברות וממשלתי – ללא הגבלה* ',
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.Policy.clientAcceptPolicy === 'לא'",
  },
  {
    fieldNumber: null,
    page: "Policy",
    object: "Policy",
    component: "Policy",
    _uid: "policyTxt",
    caption:
      'יצוין כי לגבי החלק של התיק המושקע באמצעות קרנות נאמנות )ככל שיהיה(, בחירת הקרנות אשר יכללו בתיק\nהלקוח תהיה בהתאם לרמת הסיכון שנקבעה ללקוח והחלוקה לאפיקים הנובעת ממנה. יודגש, כי מור השקעות\nאיננה מנהלת את השקעות קרן הנאמנות ובחירת הנכסים הפיננסיים ניירות הערך הנכללים בקרן מתבצעת ע"י\nמנהל הקרן בכפוף למדיניות ההשקעות של הקרן.\n* חריגה פסיבית ממדיניות ההשקעות בשיעור שאינו עולה על 10% מהשיעור שנקבע לאפיק מסויים ולתקופה\nשאינה עולה על חודש החל מתום יום המסחר בו נוצרה החריגה הפסיבית ממדיניות השקעות לא תחשב\nכחריגה ממדיניות ההשקעות.\n* במקרה של חריגה מקרית וארעית ממדיניות ההשקעה, תפעל מור השקעות להחזרת מצב תיק ההשקעות\nלמדיניות ההשקעה המפורטת לעיל תוך זמן סביר.\n* השקעת חלקו של תיק ההשקעות שלא נקבעה לגביו מדיניות השקעות בסעיף זה, תעשה על פי שיקול דעתה\nהמוחלט של מור השקעות ובכפוף להנחיותיו, צרכיו האישיים ומאפייניו של הלקוח, ובאופן שלא יהיה בו כדי\nלהגדיל את רמת הסכון של הלקוח.\nאני/ו הח"מ,\nמורה/ים לכם לנהל את תיק ההשקעות לפי שיקול דעתכם הבלעדי בבחירת סוגי ניירות הערך והנכסים הפיננסיים\nושיעורו של כל סוג ביחס לשווי התיק, בכפוף להוראות שבגוף נספח זה לגבי יחס המניות בתיק ההשקעה (סעיף ב\'\nלהלן).\nאני מצהיר/ה בזאת כי המידע המופיע לעיל, הינו המידע אותו מסרתי לידיעתו של מנהל התיקים הינו נכון ומלא\nוכי כל מידע אחר אשר נתבקשתי למסור לידיעת מנהל התיקים אולם נמנעתי מלמסור, הינו מידע אשר אין ברצוני\nשישמש את מנהל התיקים במסגרת הפעלת שיקול דעתו וייפוי כוחו לנהל את תיק ההשקעות, ואני מוותר/ת בזאת\nעל כל טענה ו/או תביעה ו/או זכות כלשהי בדבר ניהול התיקים ללא שימוש במידע זה.',
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 106,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "isCilentClssified",
    caption: "האם לקוח מסווג?",
    Type: "dxRadioGroup",
    Value: "כן/לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "risksTxt",
    caption:
      'הסכמה לניהול פעילות בנגזרים )אופציות (Options) , חוזים עתידיים, מוצרים מובנים ומכירה בחסר(\n1 . הלקוח מסכים שמור השקעות יבצע עבורו פעילות באופציות וחוזים עתידיים על מדד המעו"ף ועל כל נכס פיננסי\nאחר שייסחר בבורסה, במוצרים מובנים וביצוע מכירה בחסר.\n2 . ידוע ללקוח, כי במסגרת התקשרותו זו הוא מסכים שמור השקעות יבצע עסקאות רכישה ומכירה של אופציות\nוחוזים עתידיים הרשומים למסחר בבורסה וכן לכתוב )ליצור( אופציות אשר תרשמנה למסחר בבורסה, וכן לבצע\nעסקאות במוצרים מובנים ולבצע מכירה בחסר )להלן - ביחד - "נגזרים"(.\n3 . הלקוח מצהיר בזה כי:\nא. ידוע לו, כי כל הפעולות הכרוכות במסחר בנגזרים הינן בעלות סיכון גבוה וכי הוא קיבל הסברים ומודע לסיכון\nהרב הכרוך בהן.\nב. ידוע לו, כי הפעילות בנגזרים מושפעת מגורמים רבים ושונים ויתכנו תנודות חריפות במחיריהן.\nג. ידוע לו, כי הפעילות בכתיבת אופציות במסגרת אסטרטגיות מכר שונות שמור השקעות פועל בהן מאופיינת\nבסיכון פיננסי גבוה מאוד. ידוע לו, כי ניהול תיק השקעות שכוללת פעילות בנגזרים - פעולות אלו תבוצענה רק\nלאחר שתאושר לו ע"י הבנק מסגרת אשראי לעסקות אלה, לפי הנהלים החלים בבנק, ורק לאחר שיעמיד\nלרשות הבנק את כל הבטוחות שיידרש, להנחת דעת הבנק ומור השקעות.\n4 . הלקוח מסכים כי למור השקעות נתון שיקול הדעת המוחלט בכל עת שלא לבצע פעילות בנגזרים, לרבות פעולות\nבנגזרים שלגביהן ניתנו הוראות מאת הלקוח, וזאת אם לפי שיקול דעתו הבלעדי של מור השקעות קיים חשש\nלחריגה מבטוחות שהועמדו ע"י הלקוח לבנק, ו/או אם, לפי שיקול דעתו הבלעדי של מור השקעות, עשויות פעולות\nשהוראות לביצוען ניתנו כאמור, להביא לידי הפסדים חריגים בחשבון. בכל מקרה של אי ביצוע הוראה שניתנה ע"י\nהלקוח ו/או החלטת מור השקעות להפסקת פעילות בנגזרים או בכל חלק מהם, תינתן על כך הודעה ללקוח בסמוך\nלאחר קבלת החלטה כאמור.\nהבהרות נוספות בקשר עם השקעה בנגזרים ואזהרה מפני הסיכון הגבוה הכרוך בהשקעה בנגזרים\nבכל מקרה שבו הלקוח אישר ו/או יאשר במסגרת מדיניות ההשקעות להשקיע בנגזרים ניתנת בזאת הבהרה ואזהרה\nכדלהלן:\n1 . השקעה בנגזרים משמעה רכישת אופציות ) OPTIONS (, כתיבה )יצירה( של אופציות, רכישת חוזים עתידיים,\nהשקעה במוצרים מובנים )סטרקצ\'רים( ומכירה בחסר, לא כולל השקעה בכתב אופציה (Warrant) שהינו סוג\nשל נייר ערך המיר.\n2 . הלקוח יודע ומאשר שהוסבר לו הסיכון הכרוך בהשקעה בנגזרים. הלקוח מודע לכך שהשקעה בנגזרים, רכישתם\nומכירתם עלולה להיות כרוכה בסיכון גבוה. כן מאשר הלקוח כי הוא מודע לכך שקונה אופציה עלול להפסיד את\nמלוא השקעתו וכי כותב אופציה עלול להיחשף להפסד גבוה מאוד.\n3 . הלקוח יודע והוא מאשר כי הוסבר לו שמוצר מובנה הינו נכס מורכב אשר ההשקעה בו עלולה להיות כרוכה\nבסיכונים רבים שאינם באים לידי ביטוי בחזותו החיצונית. המכנה המשותף של הסיכונים הכרוכים בהשקעה כזו\nהוא שהם, הם אינם גלויים על פניו של המוצר והם, בדרך כלל, מוסתרים ע"י חזות של מוצר פשוט ותמים. הריבית\nבמוצר המובנה, למשל, תלויה בתשואה של המכשירים הפיננסיים השונים מהם בנוי סל ההשקעות. סיכון זה מחריף\nעוד יותר במקרים בהם ההשקעה היא ממונפת.\n4 . סיכון נוסף כרוך במרכיבי ההשקעה של המוצר המובנה, כאשר מרכיבי השקעה אלה אינם תמיד ברורים וגלויים\nלמשקיע. כן קיים סיכון בדרך בה מתומחר המוצר המובנה בעיקר בשל העובדה שמדובר במכשירים ייחודיים שלא\nתמיד נסחרים ועל כן חסרים מחיר שוק ראוי.\nמור בית השקעות ניהול תיקים בע"מ\nגרסה 12\nלקוח פרטי\n- 20 -\n5 . הלקוח מאשר כי הבין את האמור לעיל, קיבל את כל ההסברים שביקש ממור השקעות, וכי נספח זה יחול על כל\nהפעולות בנגזרים שתבוצענה בתיק ההשקעות.\nבנוסף לאמור לעיל, מאשר הלקוח ביצוע הפעולות הבאות בתיק ההשקעות שלו, ובלבד שהותאמו לצרכיו ונתוניו\nהאישיים:\nעל הלקוח לסמן את הפעולות המאושרות על ידו ולחתום ליד כל סימון:',
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 107,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "riskTashkif",
    caption:
      "עסקה בניירות-ערך אשר בתשקיף צוין כי ההשקעה בו כרוכה בסיכון \nמיוחד כל עוד לא חלפו שנתיים מתאריך התשקיף.",
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 109,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "riskOTC",
    caption:
      "עסקאות מחוץ לבורסה במחיר: בקניה - מעל המחיר בבורסה, \nבמכירה - מתחת למחיר הבורסה",
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 111,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "riskForward",
    caption: "עסקאות בחוזים עתידיים מסוג forward ו- futures",
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 113,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "riskOptions",
    caption: "עסקאות באופציות/כתבי אופציה",
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 115,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "riskStrcture",
    caption: "עסקאות במוצרים מובנים לא סחירים",
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 117,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "riskShort",
    caption: "עסקאות שכרוכה בהן מכירה בחסר",
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 120,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "riskLiquid",
    caption:
      'עסקה בניירות חסומים למסחר, לרבות בהתאם לסעיף 15 ג לחוק \nניירות ערך, התשכ"ח – 1968 )להלן: "חוק ניירות ערך"(, וכן \nקבלת ניירות כאמור בהקצאה פרטית.',
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 124,
    page: "Risks",
    object: "Policy",
    component: "Risks",
    _uid: "riskWarent",
    caption:
      "עסקאות באופציות/כתבי אופציה, אגב ביצוע עסקה בניירות \nחסומים למסחר, לרבות בהתאם לסעיף 15 ג לחוק ניירות ערך \nולרבות קבלתן כהטבה במסגרת עסקאות כאמור",
    Type: "dxCheckBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 129,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryStatus",
    caption: "מינוי מוטבים",
    Type: "dxRadioGroup",
    Value:
      "אני פועל בעבור עצמי בלבד | יש נהנה בחשבון, אולם פרטי הזיהוי שלו טרם ידועים | החשבון מנוהל למטרות קהילתיות לטובת קבוצה גדולה או קבוצה בלתי מוגדרת של נהנים )כפוף למתן אישור\nשל אחראי למילוי החובות לפי סעיף 8 לחוק)|החשבון מנוהל למטרות קהילתיות לטובת קבוצה גדולה או קבוצה בלתי מוגדרת של נהנים והיתרה בחשבון\nלא תעלה על סכום של 50,000|הנהנים בפעולה הם",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: 130,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryUnknowReason",
    caption: "הסיבה לכך",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible:
      "this.doc.account[x].beneficiaryStatus.includes('אולם פרטי הזיהוי שלו טרם ידועים')",
  },
  {
    fieldNumber: null,
    page: "",
    object: "account",
    component: "",
    _uid: "beneficiaryCount",
    caption: "מספר הנהנים",
    Type: "dxNumberBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible:
      "this.doc.account[x].beneficiaryStatus.includes('הנהנים בפעולה הם')",
  },
  {
    fieldNumber: 132,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryFirstName",
    caption: "שם פרטי",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible:
      "this.doc.account[x].beneficiaryStatus.includes('הנהנים בפעולה הם')",
  },
  {
    fieldNumber: 133,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryLastName",
    caption: "שם משפחה",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible:
      "this.doc.account[x].beneficiaryStatus.includes('הנהנים בפעולה הם')",
  },
  {
    fieldNumber: 134,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryId",
    caption: "מספר זהות",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "לבדוק ספרות 9",
    visible:
      "this.doc.account[x].beneficiaryStatus.includes('הנהנים בפעולה הם')",
  },
  {
    fieldNumber: 135,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryDOB",
    caption: "תאריך לידה",
    Type: "dxDateBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "מבנה נכון",
    visible:
      "this.doc.account[x].beneficiaryStatus.includes('הנהנים בפעולה הם')",
  },
  {
    fieldNumber: null,
    page: "",
    object: "account",
    component: "",
    _uid: "beneficiaryGender",
    caption: "מין",
    Type: "dxRadioGroup",
    Value: "זכר/נקבה",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible:
      "this.doc.account[x].beneficiaryStatus.includes('הנהנים בפעולה הם')",
  },
  {
    fieldNumber: 132,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryFirstName2",
    caption: "שם פרטי",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.account[x].beneficiaryCount >1",
  },
  {
    fieldNumber: 133,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryLastName2",
    caption: "שם משפחה",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.account[x].beneficiaryCount >1",
  },
  {
    fieldNumber: 134,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryId2",
    caption: "מספר זהות",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "לבדוק ספרות 9",
    visible: "this.doc.account[x].beneficiaryCount >1",
  },
  {
    fieldNumber: 135,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryDOB2",
    caption: "תאריך לידה",
    Type: "dxDateBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "מבנה נכון",
    visible: "this.doc.account[x].beneficiaryCount >1",
  },
  {
    fieldNumber: 136,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryGender2",
    caption: "מין",
    Type: "dxRadioGroup",
    Value: "זכר/נקבה",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.account[x].beneficiaryCount >1",
  },
  {
    fieldNumber: 132,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryFirstName3",
    caption: "שם פרטי",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.account[x].beneficiaryCount >2",
  },
  {
    fieldNumber: 133,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryLastName3",
    caption: "שם משפחה",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.account[x].beneficiaryCount >2",
  },
  {
    fieldNumber: 134,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryId3",
    caption: "מספר זהות",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "לבדוק ספרות 9",
    visible: "this.doc.account[x].beneficiaryCount >2",
  },
  {
    fieldNumber: 135,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryDOB3",
    caption: "תאריך לידה",
    Type: "dxDateBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "מבנה נכון",
    visible: "this.doc.account[x].beneficiaryCount >2",
  },
  {
    fieldNumber: 136,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryGender3",
    caption: "מין",
    Type: "dxRadioGroup",
    Value: "זכר/נקבה",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.account[x].beneficiaryCount >2",
  },
  {
    fieldNumber: 138,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryLink",
    caption: "פרט את הזיקה",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible:
      "this.doc.account[x].beneficiaryStatus.includes('הנהנים בפעולה הם')",
  },
  {
    fieldNumber: 144,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryGoal",
    caption: "מטרת החשבון",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.account[x].beneficiaryStatus.includes('למטרות')",
  },
  {
    fieldNumber: null,
    page: "beneficiary",
    object: "account",
    component: "beneficiary",
    _uid: "beneficiaryLbl",
    caption:
      "אני מתחייב להודיע למור השקעות בהקדם האפשרי על כל שינוי בפרטים שמסרתי לעיל. ידוע לי כי מסירת מידע\nכוזב, לרבות אי מסירת עדכון של פרט החייב בדיווח, במטרה שלא יהיה דיווח או כדי לגרום לדיווח בלתי נכון לפי\nסעיף 7 לחוק איסור הלבנת הון, מהווה עבירה פלילית.",
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "POA",
    object: "apendix",
    component: "POA",
    _uid: "poaHeader",
    caption: "יפוי כוח",
    Type: "Header2",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.isPoa === 'כן'",
  },
  {
    fieldNumber: 148,
    page: "agreement",
    object: "agreement",
    component: "POA",
    _uid: "isPoa",
    caption: "האם ברצונך למנות מיופה כוח?",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "POA",
    object: "apendix",
    component: "POA",
    _uid: "poaLbl",
    caption: "פרטיי מיופה הכוח",
    Type: "Header2",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.isPoa === 'כן'",
  },
  {
    fieldNumber: 149,
    page: "POA",
    object: "apendix",
    component: "POA",
    _uid: "poaFirstName",
    caption: "שם פרטי",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.agreement.isPoa === 'כן'",
  },
  {
    fieldNumber: 150,
    page: "POA",
    object: "apendix",
    component: "POA",
    _uid: "poaLastName",
    caption: "שם משפחה",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.agreement.isPoa === 'כן'",
  },
  {
    fieldNumber: 151,
    page: "POA",
    object: "apendix",
    component: "POA",
    _uid: "poaId",
    caption: "תעודת זהות",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.agreement.isPoa === 'כן'",
  },
  {
    fieldNumber: null,
    page: "POA",
    object: "apendix",
    component: "POA",
    _uid: "poaLevel",
    caption: "רמת ייפוי כוח",
    Type: "dxRadioGroup",
    Value: "מידע|הוראות|בירור צרכים",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.agreement.isPoa === 'כן'",
  },
  {
    fieldNumber: null,
    page: "BlindManaged",
    object: "apendix",
    component: "BlindManaged",
    _uid: "bilndHeader",
    caption: "הסכמה לניהול תיק השקעות בנאמנות עיוורת",
    Type: "Header2",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.isBlind === 'כן'",
  },
  {
    fieldNumber: null,
    page: "agreement",
    object: "agreement",
    component: "BlindManaged",
    _uid: "isBlind",
    caption: "נאמנות עיוורת",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "BlindManaged",
    object: "apendix",
    component: "BlindManaged",
    _uid: "BlindLbl",
    caption:
      'אני הח"מ מבקש כי חשבון ההשקעות שלי ינוהל בדרך של "נאמנות עיוורת".',
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.isBlind === 'כן'",
  },
  {
    fieldNumber: 155,
    page: "BlindManaged",
    object: "apendix",
    component: "BlindManaged",
    _uid: "BlindReason",
    caption: "הסיבה לניהול חשבוני בנאמנות עיוורת",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.agreement.isBlind === 'כן'",
  },
  {
    fieldNumber: 156,
    page: "BlindManaged",
    object: "apendix",
    component: "BlindManaged",
    _uid: "blindNotes",
    caption: "הערות בנוגע לניהול החשבון",
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "this.doc.agreement.isBlind === 'כן'",
  },
  {
    fieldNumber: null,
    page: "BlindManaged",
    object: "apendix",
    component: "BlindManaged",
    _uid: "blindTxt",
    caption:
      "ידוע לי כי במסגרת הנאמנות העיוורת חלות לגבי ההוראות הבאות:\n1 . איני רשאי לתת הוראות או הנחיות בדבר ניירות ערך או נכסים פיננסיים שיירכשו, שיוחזקו או שיימכרו\nבחשבון ההשקעות שלי.\n2 . אני רשאי לתת אך ורק הוראות כלליות, קודם לתחילת מתן השירות, בדבר סוגי הנכסים שיכללו בתיק,\nובדבר השיעור המרבי של כל סוג ביחס לשווי החשבון, לרבות רמת הסיכון בחשבון ההשקעות, ואלה\nירשמו בנספח הרלוונטי להסכם זה. לחילופין, אני רשאי להורות כי החשבון ינוהל בהתאם לשיקול דעתה\nהמוחלט של מור בית השקעות.\n3 . ידוע לי כי בחשבון ההשקעות יוחזקו גם ניירות ערך או נכסים פיננסיים אשר אני רשאי להחזיק גם ללא\nניהולם במסגרת נאמנות עיוורת.\n4. דיווח ללקוח",
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.isBlind === 'כן'",
  },
  {
    fieldNumber: 157,
    page: "BlindManaged",
    object: "apendix",
    component: "BlindManaged",
    _uid: "blindReport",
    caption: "סוג דיווח",
    Type: "dxRadioGroup",
    Value:
      "קבלת דיווח מצומצם אודות אפיקים ושיעורי החזקה, רווחי ותשלומי מס, שאינו כולל ציון ניירות\nערך ונכסים פיננסיים ספציפיים [מומלץ לכלל הלקוחות בנאמנות עיוורת ] חובה לבעלי תפקידים מיוחדים\nכדוג' שרים וח\"כים, עובדי חברי הבורסה ורשות ניירות ערך]. | קבלת דיווח מלא.",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: true,
    validation: "",
    visible: "this.doc.agreement.isBlind === 'כן'",
  },
  {
    fieldNumber: null,
    page: "BlindManaged",
    object: "apendix",
    component: "BlindManaged",
    _uid: "blindTxt2",
    caption:
      "5 . ידוע לי כי כל האמור לעיל חל עלי ועל בני משפחתי הגרים עמי או שפרנסת האחד על האחר.",
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.isBlind === 'כן'",
  },
  {
    fieldNumber: null,
    page: "InfoApproval",
    object: "apendix",
    component: "InfoApproval",
    _uid: "infoLbl",
    caption: "נספח ז' - הסכמה למסירת מידע בכל הנוגע לפרטי תיק ההשקעות",
    Type: "Header2",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.infoAllow === 'כן'",
  },
  {
    fieldNumber: null,
    page: "agreement",
    object: "agreement",
    component: "BlindManaged",
    _uid: "infoAllow",
    caption: "מידע למשווק",
    Type: "dxRadioGroup",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "InfoApproval",
    object: "apendix",
    component: "InfoApproval",
    _uid: "infoLbl2",
    caption:
      'אני הח"מ, ____________________ מספר תעודת זהות _________________,',
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.infoAllow === 'כן'",
  },
  {
    fieldNumber: 161,
    page: "InfoApproval",
    object: "apendix",
    component: "InfoApproval",
    _uid: "infoAdvisor",
    caption:
      'שהנני בעל חשבון ני"ע המנוהל על-ידי מור בית שהשקעות ניהול תיקים בע"מ )להלן – "החשבון"(, מסכים\nבזאת כי יימסר ל- _____________________________________________\nו/או למי מטעמו, בלבד, מידע אודות החשבון וזאת כל עוד לא התקבלה הודעה אחרת בחתימתי .',
    Type: "dxTextBox",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "this.doc.agreement.infoAllow === 'כן'",
  },
  {
    fieldNumber: null,
    page: "classified",
    object: "apendix",
    component: "classified",
    _uid: "classifiedTxt",
    caption:
      '1. אני_________________________ החתום בסעיף 2, ת.ז_______________, הנני משקיע\nהנמנה על המשקיעים המפורטים בתוספת הראשונה לחוק ני"ע )סעיפים 15 א)ב() 1 ( ו- 44 ל)א() 2((, היות\nומתקיימים בי התנאים המפורטים להלן והמסומנים על ידי:\nלקוח כשיר (משקיע יחיד, שאינו תאגיד)\nמתקיימים בי התנאים המנויים בתוספת הראשונה לחוק ניירות ערך, התשכ"ח- 1968 להלן: ("החוק"\nו-"התוספת הראשונה לחוק") ואני משקיע מסווג הואיל ומתקיים בי לפחות תנאי אחד מבין התנאים\nשלהלן:',
    Type: "TextStat",
    Value: "",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: null,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "agreement",
    caption: "הסכם",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "spamApendix",
    caption: "נספח א' - אישורים מיוחדים",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "naApendix",
    caption: "נספח ב' - אפיון הלקוח ומדיניות השקעה",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "risksApendix",
    caption: "נספח ג' - עסקאות בסיכון מיוחד",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "beneficeryApendix",
    caption: "נספח ד' - טופס הצהרה על נהנה ובעל שליטה – ימולא ע\"י הלקוח",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "poaApendix",
    caption: "נספח ה' - טופס יפוי כוח",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "blindApendix",
    caption: "נספח ו' - הסכמה לניהול תיק השקעות בנאמנות עיוורת",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "advisorApendix",
    caption: "נספח ז' - הסכמה למסירת מידע בכל הנוגע לפרטי תיק ההשקעות",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
  {
    fieldNumber: null,
    page: "",
    object: "files",
    component: "files",
    _uid: "classifiedApendix",
    caption: "נספח ח' - הצהרת לקוח מסווג",
    Type: "dxCheckBox",
    Value: "כן|לא",
    editByRep: null,
    editByClient: null,
    visibleToClient: null,
    require: false,
    validation: "",
    visible: "",
  },
];

function groupBy3(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}

function getApi() {
  const url =
    "https://sheets.googleapis.com/v4/spreadsheets/1iFjNl76JIxR4yU9b3Kyk1IeRk6A4UcbDPHKJFjtQeFY/values/Sheet1?alt=json&key=AIzaSyApxSS-I9j1vr9Ifw5NZfC-d6wjjuP-Cnw";

  return fetch(url, {
    method: "GET",
  }).then(function (response) {
    return response.json();
  });
}

// https://levelup.gitconnected.com/google-sheets-api-tutorial-with-javascript-588f581aa1d9

const getSheetValuesAsync = async () => {
  //   const url = 'https://sheets.googleapis.com/v4/spreadsheets/1iFjNl76JIxR4yU9b3Kyk1IeRk6A4UcbDPHKJFjtQeFY/values/Sheet1?alt=json&key=AIzaSyApxSS-I9j1vr9Ifw5NZfC-d6wjjuP-Cnw';

  const request = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  const data = await request.json();
  return data.values;
};

const getSheetValues = () => {
  return fetch(url, {
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((responseJson) => {
      return responseJson.values;
    });
};

function addKey(object) {
  let header = object[0];
  let c = 0;
  let reslt = [];

  for (const property in object) {
    if (c > 0) {
      let x = {};
      let i = 0;
      for (const h in header) {
        x[header[h]] = object[property][h];
        i++;
      }
      reslt.push(x);
    }
    c++;
  }

  return reslt;
}

export default {
  getEmployee() {
    return structuredClone(employee);
  },

  getTemplate() {
    return groupBy3(template, "object");
  },

  async getTemplateApiAsync() {
    const responseJson = await getSheetValues();
    const temp = addKey(responseJson);
    const tembByKey = groupBy3(temp, "object");

    return tembByKey;
  },
};
